type LogMethod = (...args: unknown[]) => void

interface ClientLogger {
  debug: LogMethod
  error: LogMethod
  info: LogMethod
  log: LogMethod
  table: LogMethod
  trace: LogMethod
  warn: LogMethod
}

const callConsole = (method: keyof Console, args: unknown[]) => {
  const target = globalThis.console?.[method]
  if (typeof target === 'function') {
    target.apply(globalThis.console, args)
  }
}

export const logger: ClientLogger = {
  debug: (...args) => callConsole('debug', args),
  error: (...args) => callConsole('error', args),
  info: (...args) => callConsole('info', args),
  log: (...args) => callConsole('log', args),
  table: (...args) => callConsole('table', args),
  trace: (...args) => callConsole('trace', args),
  warn: (...args) => callConsole('warn', args),
}
